// client/src/components/pacotesCliente/FiltroPacotesCliente.js - VERSÃO 100% PADRONIZADA
import React, { useState } from 'react';
import { Search, X, Filter, Loader2 } from 'lucide-react';
import PropTypes from 'prop-types';

const FiltroPacotesCliente = ({ onApplyFilters, loading, clientes = [] }) => {
    const [clienteId, setClienteId] = useState('');

    const onSubmit = e => {
        e.preventDefault();
        if (onApplyFilters) {
            onApplyFilters({ cliente: clienteId });
        }
    };

    const handleClear = () => {
        setClienteId('');
        if (onApplyFilters) {
            onApplyFilters({});
        }
    };

    return (
        <form onSubmit={onSubmit} className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
                
                {/* 1. Seleção de Cliente */}
                <div className="flex flex-col gap-1 md:col-span-2 lg:col-span-2">
                    <label htmlFor="filtro-cliente" className="text-xs font-semibold text-gray-600 uppercase">Filtrar por Cliente</label>
                    <select 
                        id="filtro-cliente" 
                        value={clienteId} 
                        onChange={e => setClienteId(e.target.value)} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                    >
                        <option value="">Todos os Clientes</option>
                        {clientes.map(c => (
                            <option key={c._id} value={c._id}>
                                {c.nomeCompleto || c.razaoSocial || c.user?.name || 'Cliente sem nome'}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Botões de Ação — antes reinventava cor do zero em Tailwind
                    (bg-blue-600) e o texto "Buscar" so aparecia acima de 640px
                    (hidden sm:inline) */}
                <div className="flex gap-2 h-full items-end">
                    <button
                        type="submit"
                        disabled={loading}
                        className="action-button action-button-primary flex-1 justify-center"
                        title="Buscar Pacotes"
                    >
                        {loading ? <Loader2 size={18} className="icon animate-spin" /> : <Search size={18} className="icon" />}
                        Buscar
                    </button>

                    {clienteId && (
                        <button
                            type="button"
                            onClick={handleClear}
                            disabled={loading}
                            className="action-button action-button-secondary justify-center"
                            title="Limpar Filtro"
                        >
                            <X size={18} className="icon" />
                        </button>
                    )}
                </div>
            </div>

            {/* Resumo de Filtros */}
            {clienteId && (
                <div className="mt-4 pt-3 border-t border-gray-200 flex items-center justify-between text-xs text-gray-500">
                    <div className="flex items-center gap-2">
                        <Filter size={14} className="text-blue-600" />
                        <span>Filtro ativo:</span>
                        <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-medium">
                            Cliente Selecionado
                        </span>
                    </div>
                    <button onClick={handleClear} className="text-red-600 hover:text-red-800 hover:underline">
                        Limpar
                    </button>
                </div>
            )}
        </form>
    );
};

FiltroPacotesCliente.propTypes = {
    onApplyFilters: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    clientes: PropTypes.array
};

export default FiltroPacotesCliente;